import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CompanyOverview from './components/CompanyOverview';
import EngineeringApproach from './components/EngineeringApproach';
import FooterContact from './components/FooterContact';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CompanyOverview />
        <EngineeringApproach />
      </main>
      <FooterContact />
    </>
  );
}